import React, { useState } from "react";
import NavTab from "components/navigation/NavTab";
import CountsMenu from "./CountsMenu";
import ProjectMenu from "./ProjectMenu";

const SideMenu = ({ joyrideStart, setActiveCountsTab, activeCountsTab }) => {
    const [activeTab, setActiveTab] = useState("projects");

    return (
        <div className="w-[26%] h-screen fixed left-0 top-20 dark:text-white flex">
            <>
                <NavTab setActiveTab={setActiveTab} />
            </>
            <div className="w-[78%] border-r border-[#D9D9D9] dark:border-[#424E59]">
                {activeTab === "projects" ? (
                    <ProjectMenu joyrideStart={joyrideStart} />
                ) : (
                    <CountsMenu
                        setActiveCountsTab={setActiveCountsTab}
                        activeCountsTab={activeCountsTab}
                    />
                )}
            </div>
        </div>
    );
};
export default SideMenu;
